export class EbyMessage {
    public tabName = 'homePage'
    public phone = ''
    public personName=''
    public url=''

    public static of(o: unknown): EbyMessage {
        return Object.assign(new EbyMessage(), o);
    }
}